// assets
import { IconDashboard } from '@tabler/icons-react';

// constant
const icons = { IconDashboard };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
  id: 'dashboard',
  // title: 'Dashboard',
  type: 'group',
  children: [
    {
      id: 'default',
      title: 'Developers Docs',
      type: 'item',
      url: 'https://taraldocs.tarality.com/getting-started/developer-guide',
      icon: icons.IconDashboard,
      breadcrumbs: false
    },
    {
      id: 'Validator',
      title: 'Become Validator',
      type: 'item',
      url: 'https://taraldocs.tarality.com/getting-started/developer-guide/nodes-and-validators',
      icon: icons.IconDashboard,
      breadcrumbs: false
    },
    {
      id: 'ICO',
      title: 'ICO',
      type: 'item',
      url: '#',
      icon: icons.IconDashboard,
      breadcrumbs: false
    },
    {
      id: 'Community',
      title: 'Join The Community',
      type: 'item',
      url: '#',
      icon: icons.IconDashboard,
      breadcrumbs: false
    },
    {
      id: 'litepaper',
      title: 'Download Litepaper',
      type: 'item',
      url: '#',
      icon: icons.IconDashboard,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
